import * as React from 'react';
import BaseLayout from '../../components/BaseLayout';

const List: React.FC = () => <BaseLayout />;

// eslint-disable-next-line import/prefer-default-export
export { List };
